import React, { useMemo } from 'react'
import moment from 'moment'

export default ({dataItem, field}) => {
    const value = dataItem[field]
    const output = useMemo(() => {
        return moment(value).format('DD.MM.YYYY').replace('Invalid date', '')
    }, [value])
    return <td>
        {output}
    </td>
}



// WEBPACK FOOTER //
// ./src/components/common/DateCell.js